import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserCard } from "../../store/card/selectors";
import { cardActions } from "../../store/card";
import { getUserPackages } from "../../store/packages/selectors";
import { packagesActions } from "../../store/packages";
import { cards, tv, feedback, user } from "../../lib/api/api";

import MobileMenu from "../../sections/mobileMenu/mobileMenu";
import Header from "../../sections/header/header";
import InfoCards from "../../sections/infoCards/infoCards";
import FillUpAccount from "../../sections/fillupAccount/fillupAccount";
import SputnikPackageSelection from "../../sections/packageSelection/packageSelection";
import MorePossibilities from "../../sections/morePossibilities/morePossibilities";
import BonusBanner from "../../sections/bonusBanner/bonusBanner";
import TVProgram from "../../sections/tvProgram/tvProgram";
import Announcements from "../../sections/announcements/announcements";
import News from "../../sections/news/news";
import Banner90Days from "../../sections/banner90Days/banner90Days";
import Footer from "../../sections/footer/footer";
import CartPicker from "../../sections/cartPicker/cartPicker";
import ServiceSwitch from "../../sections/serviceSwitch/serviceSwitch";
import PopupForm from "../../sections/popupForm/popupForm";
import CallbackForm from "../../sections/callbackForm/callbackForm";

const Sputnik = () => {
  const [message, setMessage] = useState("");
  const [additionalPackages, setAdditionalPackages] = useState([]);
  const [basicPackage, setBasicPackage] = useState({});
  const [basicChannelList, setBasicChannelList] = useState([]);
  const [channelList, setChannelList] = useState([]);
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [packageToDelete, setPackageToDelete] = useState({});
  const [telekartaOnline, setTelekartaOnline] = useState(0);
  const [finalSlide, setFinalSlide] = useState(false);
  const [connectedPackages, setConnectedPackages] = useState({});
  const [loading, setLoading] = useState(false);
  const [promotions, setPromotions] = useState([]);
  const [services, setServices] = useState([]);

  const [authStatus, setAuthStatus] = useState("checking");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const card = useSelector(getUserCard);
  const packages = useSelector(getUserPackages);
  const subscriptions = packages.list.filter((item) => item.type.id !== "1");
  const basicPackages = packages.list.filter((item) => item.type.id === "1");

  useEffect(() => {
    if (basicPackages.length > 0) {
      setBasicPackage(basicPackages[0]);
      setBasicChannelList(basicPackages[0].tv_channels);
    }
  }, [basicPackages]);

  useEffect(() => {
    let isActive = true;
    
    user
      .userInfo()
      .then((res) => {
        if (!isActive) return;

        const perms = Array.isArray(res?.permissions) ? res.permissions : [];
        const isPartner = perms.some((p) => p.type === "user.partner");
        const hasAgreement = perms.some((p) => p.type === "user.agree");

        if (isPartner) {
          setAuthStatus("unauth");
          window.location.replace("https://my.telekarta.tv");
          return;
        }
        if (!hasAgreement) {
          setAuthStatus("ok");
          navigate("/agreement");
          return;
        }

        setAuthStatus("ok");
      })
      .catch(() => {
        if (!isActive) return;
        setAuthStatus("unauth");
        window.location.replace("https://my.telekarta.tv");
      });

    return () => {
      isActive = false;
    };
  }, [navigate]);

  useEffect(() => {
    if (authStatus !== "ok") return;

    if (!card.loading) {
      cards
        .userCard()
        .then((res) => {
          dispatch(
            cardActions.setCard({
              title: res[0].title,
              cardID:
                res[0].hasOwnProperty("card_control") &&
                res[0].card_control !== ""
                  ? res[0].card_id + res[0].card_control
                  : res[0].card_id,
              ID: res[0].id,
              billingID: res[0].billing_id,
              loading: true,
            })
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
    tv.tvChannels()
      .then((res) => {
        setChannelList(res.channels);
      })
      .catch((err) => {
        console.log(err);
      });
    tv.services()
      .then((res) => {
        setServices(res.services);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [authStatus, card.loading]);

  useEffect(() => {
    if (authStatus !== "ok") return;
    if (card.ID == null) return;

    if (!packages.loading) {
      cards
        .subscriptions(card.ID)
        .then((res) => {
          dispatch(
            packagesActions.setPackages({ list: res, ...{ loading: true } })
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [authStatus, card.ID, packages.loading]);

  useEffect(() => {
    if (authStatus !== "ok") return;
    if (card.cardID == null) return;
    cards
      .activeSubscriptions(card.cardID)
      .then((res) => {
        if (Array.isArray(res)) {
          setAdditionalPackages(res);
        } else {
          const resArray = [];
          for (let key in res) {
            resArray.push(res[key]);
          }
          setAdditionalPackages(resArray);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    const cookie = getCookie();
    if (cookie.can_register) {
      setTelekartaOnline(cookie.can_register);
      searchParameter();
    } else {
      feedback
        .telekartaOnline(card.cardID)
        .then((res) => {
          setTelekartaOnline(res.can_register);
          searchParameter();
          document.cookie = `can_register=${res.can_register}`;
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [authStatus, card.cardID]);

  function getCookie() {
    return document.cookie.split("; ").reduce((acc, item) => {
      const [name, value] = item.split("=");
      acc[name] = value;
      return acc;
    }, {});
  }

  function searchParameter() {
    const parameters = window.location.search.substr(1);
    if (parameters) {
      const obj = parameters.split("&").reduce((res, a) => {
        var t = a.split("=");
        res[decodeURIComponent(t[0])] =
          t.length == 1 ? null : decodeURIComponent(t[1]);
        return res;
      }, {});
      if (obj.banner && obj.banner === "true") {
        setTelekartaOnline(1);
        setFinalSlide(true);
      }
    }
  }

  return (
    <>
      <MobileMenu />
      <div className="page page--index page--cabinet cart-picker-active">
        <Header />
        <main className="page__main">
          <InfoCards
            setLoading={setLoading}
            card={card}
            subscriptions={subscriptions}
            basicPackage={basicPackage}
            additionalPackages={additionalPackages}
            message={message}
            setMessage={setMessage}
            promotions={promotions}
            setPromotions={setPromotions}
          />
          <div style={loading ? {} : { overflow: "hidden", height: "0px" }}>
            <FillUpAccount cardID={card.cardID} setMessage={setMessage} />
            {Object.keys(basicPackage).length !== 0 && (
              <SputnikPackageSelection
                basicPackage={basicPackage}
                basicChannelList={basicChannelList}
                channelList={channelList}
              />
            )}
            <MorePossibilities
              ID={card.ID}
              cardID={card.cardID}
              selectedPackages={selectedPackages}
              setSelectedPackages={setSelectedPackages}
              setPackageToDelete={setPackageToDelete}
              connectedPackages={connectedPackages}
              changeMessage={setMessage}
              promotions={promotions}
              services={services}
            />
            <BonusBanner />
            <TVProgram />
            <Announcements />
            <News />
            {telekartaOnline && <Banner90Days finalSlide={finalSlide} />}
          </div>
        </main>
        <Footer />
        {subscriptions.length > 0 && (
          <CartPicker
            ID={card.ID}
            subscriptions={subscriptions}
            selectedPackages={selectedPackages}
            setSelectedPackages={setSelectedPackages}
            setConnectedPackages={setConnectedPackages}
            changeMessage={setMessage}
          />
        )}
        <ServiceSwitch
          ID={card.ID}
          packageToDelete={packageToDelete}
          setPackageToDelete={setPackageToDelete}
          changeMessage={setMessage}
        />
        <PopupForm setMessage={setMessage} />
        <CallbackForm />
      </div>
    </>
  );
};

export default Sputnik;
